module.exports = __webpack_public_path__ + "img/Deng.27b53a92.jpg";